/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/

export default tzPattern



//////////////////
// WEBPACK FOOTER
// ./~/date-fns-tz/esm/_lib/tzPattern/index.js
// module id = 1028
// module chunks = 93